(function(){
  'use strict';
  var form = document.getElementById('PdpForm');
  if(!document.getElementById('ProductMedia') && !form) return;

  var moneyFormat = window.PRAYASA_MONEY_FORMAT || 'Rs. {{amount}}';
  function prayasaMoney(cents){
    var amount = (parseInt(cents,10) || 0) / 100;
    var s = amount.toLocaleString('en-IN', {minimumFractionDigits:2, maximumFractionDigits:2});
    var fmt = String(moneyFormat).replace(/<[^>]*>/g,'');
    if(fmt.indexOf('amount') === -1){ return fmt + s; }
    return fmt.replace(/\{\{\s*amount(_[a-z_]+)?\s*\}\}/gi, s).replace(/\$\{\{\s*amount(_[a-z_]+)?\s*\}\}/gi, s);
  }

  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pp__thumbs .thumb'));
  var mediaItems = Array.prototype.slice.call(document.querySelectorAll('.pp__media-item'));

  function showMedia(id, button){
    mediaItems.forEach(function(item){
      var active = item.getAttribute('data-media-id') === id;
      item.classList.toggle('on', active);
      if(!active){ var video = item.querySelector('video'); if(video) video.pause(); }
    });
    thumbs.forEach(function(thumb){
      var active = thumb === button;
      thumb.classList.toggle('on', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function showMediaById(id){
    if(!id) return;
    var targetThumb = null;
    thumbs.forEach(function(thumb){ if(thumb.getAttribute('data-target') === id) targetThumb = thumb; });
    if(targetThumb){ showMedia(id, targetThumb); return; }
    var found = false;
    mediaItems.forEach(function(item){
      var active = item.getAttribute('data-media-id') === id;
      if(active) found = true;
      item.classList.toggle('on', active);
      if(!active){ var video = item.querySelector('video'); if(video) video.pause(); }
    });
    if(!found && mediaItems[0]){ mediaItems.forEach(function(item, i){ item.classList.toggle('on', i === 0); }); }
  }

  thumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){ showMedia(thumb.getAttribute('data-target'), thumb); });
  });

  var qty = document.getElementById('Qty');
  document.querySelectorAll('[data-q]').forEach(function(button){
    button.addEventListener('click', function(){
      if(!qty) return;
      var value = parseInt(qty.value || '1', 10) + parseInt(button.getAttribute('data-q'), 10);
      qty.value = Math.max(1, value);
    });
  });

  var select = document.getElementById('VarSel');

  function updateAvailability(available){
    var stock = document.getElementById('StockLine');
    var atc = document.getElementById('AtcBtn');
    var atcText = document.getElementById('AtcText');
    var sticky = document.getElementById('StickyBtn');
    if(stock){
      stock.className = 'stockline' + (available ? '' : ' out');
      stock.innerHTML = '<span class="dot2"></span>' + (available ? 'Available, ready to order' : 'Currently sold out');
    }
    if(atc){ atc.disabled = !available; }
    if(atcText){ atcText.textContent = available ? 'Add to cart' : 'Sold out'; }
    if(sticky){ sticky.disabled = !available; sticky.textContent = available ? 'Add to cart' : 'Sold out'; }
    if(form){ form.classList.toggle('is-soldout', !available); }
  }

  if(form){ form.classList.toggle('is-soldout', window.PRAYASA_PDP_AVAILABLE === false); }

  if(select){
    select.addEventListener('change', function(){
      var option = select.options[select.selectedIndex];
      var price = document.getElementById('PdpPrice');
      var compare = document.getElementById('PdpCompare');
      var save = document.getElementById('PdpSave');
      var stickyPrice = document.getElementById('StickyPrice');
      var priceCents = parseInt(option.getAttribute('data-price'), 10) || 0;
      var compareCents = parseInt(option.getAttribute('data-compare'), 10) || 0;
      var hasCompare = compareCents > priceCents;
      var available = option.getAttribute('data-avail') === 'true';
      if(price) price.textContent = prayasaMoney(priceCents);
      if(stickyPrice) stickyPrice.textContent = prayasaMoney(priceCents);
      if(compare){ compare.style.display = hasCompare ? '' : 'none'; compare.textContent = hasCompare ? prayasaMoney(compareCents) : ''; }
      if(save){ save.style.display = hasCompare ? '' : 'none'; save.textContent = hasCompare ? ('You save ' + prayasaMoney(compareCents - priceCents)) : ''; }
      updateAvailability(available);
      var mediaId = option.getAttribute('data-media');
      if(mediaId){ showMediaById(mediaId); }
      if(window.history && window.history.replaceState){
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url.toString());
      }
    });
  }

  var stickyBar = document.getElementById('StickyAtc');
  var stickyButton = document.getElementById('StickyBtn');
  if(stickyButton && form){
    stickyButton.addEventListener('click', function(){
      if(stickyButton.disabled) return;
      if(form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }

  if(stickyBar && form){
    var ticking = false;
    function updateSticky(){
      var formRect = form.getBoundingClientRect();
      var footer = document.querySelector('.fut');
      var footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      var on = formRect.bottom < 0 && footerTop > window.innerHeight * .72;
      stickyBar.classList.toggle('on', on);
      document.body.classList.toggle('atc-on', on);
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if(!ticking){ requestAnimationFrame(updateSticky); ticking = true; }
    }, {passive:true});
    updateSticky();
  }
})();
